import CodeAndDocumentation from "@/components/pages/Community/CodeAndDocumentation/CodeAndDocumentation";

export default CodeAndDocumentation;
